<div class="modal-header">
  <h4 class="modal-title">
    <ng-container *ngIf="(author$ | async) as author; else loadingtitle">Biography for {{author.name}}</ng-container>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <ng-container *ngIf="(author$ | async) as author; else loading">
    <div [innerHTML]="author.body"></div>
  </ng-container>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="activeModal.close('Close click')">Close</button>
</div>

<ng-template #loadingtitle>Author Biography</ng-template>
<ng-template #loading>
  <app-load-indicator description="load this biography"></app-load-indicator>
</ng-template>
